import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { getSettings } from "@common/settingsProvider";
import { createPdfUrl } from "@common/pdfUrlHelper";
import { downloadFile } from "@common/api/downloadFile";
import { useTranslation } from "@localization/useTranslation";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider";

export function useDownloadManagementReport() {
    const { translateString } = useTranslation();
    const { language } = useUserContext();
    const snackbar = useDotLegalSnackbar();

    const [isDownloadingManagementReport, setIsDownloadingManagementReport] = useState(false);

    const onDownloadManagementReport = async (reportUrl: string, groupName: string, sender: string) => {
        setIsDownloadingManagementReport(true);

        let url = getSettings().mainSiteBaseUrl + reportUrl + "?isPdf=true";
        url = createPdfUrl(url, language);

        const fileName = `${translateString("managementReport")}_${groupName}_${sender}.pdf`;
        await downloadFile(getSettings().apiBaseUrl + "/pdf/generate?noMargin=true&url=" + url, fileName);

        setIsDownloadingManagementReport(false);
        snackbar.show(createElement(Trans, { i18nKey: "pdfDownloadComplete", values: { fileName: fileName } }));
    };

    return {
        onDownloadManagementReport,
        isDownloadingManagementReport,
    };
}
